module.exports = __webpack_public_path__ + "static/media/peacock-trans.54487b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/peacock-trans.png
// module id = 1629
// module chunks = 0